import React from "react";
import { View, StyleSheet } from "react-native";
import { tokens } from "./tokens";

export const clampPercent = (value) =>
  Math.max(0, Math.min(100, Number(value) || 0));

// `scanned` / `total` of a list. 0 when there is nothing to count.
export const toPercent = (done, total) =>
  total > 0 ? clampPercent((done / total) * 100) : 0;

/**
 * Horizontal fill bar.
 * @param percent 0–100 (clamped)
 * @param color   fill colour, default the dark store green
 */
const ProgressBar = ({
  percent = 0,
  color = tokens.primary,
  height = 8,
  testID,
}) => (
  <View
    testID={testID}
    style={[styles.track, { height, borderRadius: height / 2 }]}
  >
    <View
      style={[
        styles.fill,
        {
          width: `${clampPercent(percent)}%`,
          backgroundColor: color,
          borderRadius: height / 2,
        },
      ]}
    />
  </View>
);

export default ProgressBar;

const styles = StyleSheet.create({
  track: {
    width: "100%",
    backgroundColor: tokens.borderLight,
    overflow: "hidden",
  },
  fill: { height: "100%" },
});
